// extracted by mini-css-extract-plugin
module.exports = {"list":"MarketingFaqList_list__b9j5J","listItem":"MarketingFaqList_listItem__0EtFD","question":"MarketingFaqList_question__5wdaX","answer":"MarketingFaqList_answer__aR_iE"};